export default __webpack_public_path__ + "static/media/main-picture.5ba78377.png";